<template>
  <el-row>
    <el-row class="BannerContWidth">
      <el-col :span="24">
		  <el-col :md="{span: 7,offset: 1}"
		          :sm="{span: 8,offset: 0}"
		          class="hidden-xs-only">
			<div class="my-menu">
				<img src='../assets/images/icon.jpg' />
				<div class="LoginCont"
				     v-if="AllUserInfo">{{AllUserInfo.email!='' ? AllUserInfo.email : AllUserInfo.fullName}}</div>
			</div>
		    <!-- <QRCode></QRCode> -->
		  </el-col>
        <el-col :span="16"
                :xs='24'>
          <div class="DetailsCont">
			  ri
<!--            <div class="FindCont"
                 v-for="(item, ind) in ArticleListData"
                 :key="ind"
                 @click="ToArticleDetails(item.announcement_id)">
              <p>{{$t('publishType.'+item.publish_type)}}</p>
              <img :src=" item.title_url">
              <div class="FindDetailsCont">
                <div class="FindDetails">
                  <div>
                    <p class="FindDetailsTitle">{{item.title}}</p>
                  </div>
                </div>
              </div>
            </div> -->
          </div>
        </el-col>
        
      </el-col>
    </el-row>
    <foot></foot>
  </el-row>
</template>

<script>
// import QRCode from '@/components/QRCode'
import foot from '@/components/foot'
export default {
  name: 'product',
  components: {
    // QRCode,
    foot
    // VueScrollbar
  },
  data () {
    return {
      AllUserInfo: '',
    }
  },
  created () {
    this.UserInfoLogin()
  },
  computed: {

  },
  mounted () {

  },
  methods: {
	  UserInfoLogin () {
	    if (this.$store.state.count) {
	      if (typeof (this.$store.state.count) == 'string') {
	        this.AllUserInfo = JSON.parse(this.$store.state.count)
	      } else {
	        this.AllUserInfo = this.$store.state.count
	      }
	    } else {
	      this.AllUserInfo = ''
	    }
	  
	    this.token = this.$store.state.token
	  }
  },
  updated () { }
}
</script>

<style lang="less" scoped>
.BannerContWidth {
  width: 1040px;
  display: flex;
  margin: 20px auto;
}
.DetailsCont {
  width: 100%;
  margin: 1.5rem 0;
}

.FindCont {
  width: 100%;
  margin: 0 0 15px 0;
  cursor: pointer;
  box-shadow: 0 2px 2px rgba(0, 0, 0, 0.05);
  border-radius: 3px;
  overflow: hidden;
}
.FindCont > p {
  font-size: 14px;
  line-height: 20px;
  padding: 10px 15px;
  color: #999;
  background: #fff;
}
.FindCont > img {
  width: 100%;
  display: block;
}
.FindDetailsCont {
  width: 100%;
  background: white;
  display: flex;
  justify-content: space-between;
}
.FindDetails {
  display: flex;
  padding: 1rem 0;
  line-height: 2.333rem;
  padding-left: 0.833rem;
}
.FindDetailsTitle {
  font-size: 16px;
  line-height: 28px;
  color: #333;
  font-weight: 700;
}
.FindDetails > img {
  width: 4.75rem;
  height: 4.75rem;
  margin-right: 1rem;
  border-radius: 1rem;
}

.my-menu{
	width: 100%;
	// margin: 1.5rem 0;
	text-align: center;
	border-radius: 3px;
	// padding: 15px 25px 10px 10px;
	background: #fff;
	padding: 15px 0;
	img{
		border-radius: 50%;
		margin: 0 0 0 15px;
		width: 4rem;
		height: 4rem;
	}
}

@media (max-width: 1200px) {
  .BannerContWidth {
    width: 88%;
  }
}
@media (max-width: 992px) {
  .BannerContWidth {
    width: 84%;
  }
}
@media (max-width: 768px) {
  .BannerContWidth {
    width: 82%;
  }
}
@media (max-width: 576px) {
  .BannerContWidth {
    width: 90%;
  }
  .FindCont > img {
    // height: 150px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/my.vue